import { ToothData } from "../../../duck";

export const getToothData = (tooth: Omit<ToothData, "toothState">) => {
  const periodontalPockets: string[] = [];
  const otherData: string[] = [];

  Object.entries(tooth).forEach(([key, value]) => {
    if (key.includes("periodontalPocket")) {
      periodontalPockets.push(value);
    } else {
      otherData.push(value);
    }
  });

  return {
    periodontalPockets: periodontalPockets.join(", "),
    data: otherData.join(", ")
  };
};
